import React from 'react';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import SkeletonView from '@@viewCommonComponents/groupProtection/SkeletonView.jsx';

const SouscriptionActivePolicyGroupProtection = ({ getMiddleText }) => (
  <SkeletonView title={'Couverture actuelle'} getMiddleText={getMiddleText} />
);

export default withMiddleFeatures(SouscriptionActivePolicyGroupProtection);
